import { createAutoCorrectedDatePipe } from 'text-mask-addons'
import lastDateByPeriod from 'utils/pivot/date/lastDateByPeriod'
import baseControllerInput from './baseControllerInput'
import getErrorEndDate from './validations/endDate'
import { alterDate, stringToDate } from '@hc-frontend/utils'
import { DATE_REGEX } from 'core/constants/regex'

export default ({ getStatus }) =>
  ({ input, ...params }) => {
    const field = $(input)
    const controller = baseControllerInput({
      getErrorMessage: state => {
        const storage = getStatus()

        return getErrorEndDate({
          sDate: storage.sDate,
          endDate: state.input.value,
          period: storage.period
        })
      },
      maskConfig: {
        mask: DATE_REGEX,
        pipe: createAutoCorrectedDatePipe('mm/dd/yyyy'),
        keepCharPositions: true
      }
    })({ input, ...params })

    field.datepicker({
      trigger: `#wrap-${input.name} .hc-icon-calendar`,
      autoHide: true,
      show: () => {
        const storage = getStatus()
        const sDate = stringToDate(storage.sDate)
        const period = storage.period

        field.datepicker(
          'setStartDate',
          alterDate({
            date: sDate,
            days: storage.prepaid ? 59 : period === 364 || period === 330 ? 180 : 29
          })
        )

        field.datepicker('setEndDate', lastDateByPeriod(sDate, period))
        field.datepicker('setDate', storage.endDate)
      },
      hide: () => {
        setTimeout(controller.validate, 0)
      }
    })

    return controller
  }
